import { render, staticRenderFns } from "./inventory-claim.vue?vue&type=template&id=440b2952&scoped=true&"
import script from "./inventory-claim.vue?vue&type=script&lang=js&"
export * from "./inventory-claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b2952",
  null
  
)

export default component.exports